export { default } from "./AuthButton";
